import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useQuery } from "react-query";
import DeleteModal from "./DeleteModal";
import { GetFileExpandData } from "Services/PGXLis/ResultUpload";
import { Loader } from "Shared/Common/Loader";
import PermissionComponent, {
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";
import useLang from "Shared/hooks/useLanguage";
import NoRecord from "Shared/Common/NoRecord";

interface ExpandProps {
  fileId: number;
}

const Expand = ({ fileId }: ExpandProps) => {
  const { t } = useLang();

  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);

  const {
    data = [],
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["expandData", fileId],
    queryFn: async () => {
      const res = await GetFileExpandData(fileId);
      return res?.data?.data || [];
    },
    enabled: !!fileId,
  });

  return (
    <>
      <DeleteModal
        show={show}
        setShow={setShow}
        selectedRecord={selectedId}
        refetch={refetch}
      />
      <div className="py-2">
        <div className="table_bordered overflow-hidden">
          <TableContainer className="shadow-none">
            <Table
              aria-label="sticky table collapsible"
              className="table table-cutome-expend table-bordered table-sticky-header table-head-2-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
            >
              <TableHead className="h-30px">
                <TableRow>
                  <TableCell className="text-center min-w-50px w-50px">
                    {t("Actions")}
                  </TableCell>

                  {Object.entries(data?.columns ?? {})
                    .filter(([key]) => key !== "RawDataId")
                    .map(([key, value]) => {
                      const label = String(value);

                      return (
                        <TableCell
                          key={key}
                          sx={{ whiteSpace: "nowrap" }} // prefer sx if using MUI
                          style={{ width: "auto" }} // keep inline only if needed
                        >
                          {label}
                        </TableCell>
                      );
                    })}
                </TableRow>
              </TableHead>

              <TableBody>
                {isFetching ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : !data?.data?.length ? (
                  <NoRecord colSpan={5} />
                ) : (
                  data?.data?.map((row: any) => (
                    <TableRow key={row?.RawDataId}>
                      <TableCell>
                        <div className="d-flex justify-content-center rotatebtnn">
                          <DropdownButton
                            className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                            id={`AdminUserList3Dots_${row?.RawDataId}`}
                            drop="end"
                            title={
                              <i className="bi bi-three-dots-vertical p-0"></i>
                            }
                          >
                            <PermissionComponent
                              moduleName="PGX LIS"
                              pageName="Result File"
                              permissionIdentifier="Delete"
                            >
                              {({
                                pageName,
                                moduleName,
                                permissionIdentifier,
                              }) => (
                                <Dropdown.Item
                                  className="menu-item p-0"
                                  onClick={() => {
                                    setSelectedId(row.RawDataId);
                                    setShow(true);
                                  }}
                                >
                                  <span className="menu-link text-dark">
                                    <i className="fa-solid fa-trash text-danger mr-2 w-20px"></i>
                                    {getPermissionDisplayName(
                                      pageName,
                                      moduleName,
                                      permissionIdentifier,
                                      "Delete"
                                    )}
                                  </span>
                                </Dropdown.Item>
                              )}
                            </PermissionComponent>
                          </DropdownButton>
                        </div>
                      </TableCell>
                      {Object.entries(data?.columns ?? {})
                        .filter(([key]) => key !== "RawDataId")
                        .map(([key]) => (
                          <TableCell key={key}>{row[key]}</TableCell>
                        ))}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default Expand;
